const resource = 'recommendations'

export default (axios) => ({
  count (params) {
    return axios.get(`${resource}/count`, params)
  },
})
